export default sideView => (
  [
    {
      path: '/',
      name: 'index',
      meta: {
        title: '考试大厅',
        showBack: false
      },
      components: {
        default: () => import(/* webpackChunkName: "examination" */'./views/index'),
        side: sideView
      }
    },
    {
      path: '/examination/:courseId',
      name: 'examination',
      meta: {
        title: '考试信息载入中...',
        showBack: false
      },
      component: () => import(/* webpackChunkName: "examination" */'./views/examination')
    }
  ]
)
